"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAcnSearchRequest = exports.acnSearchSchema = void 0;
const yup = __importStar(require("yup"));
const ValidationError_1 = require("../errors/ValidationError");
const CompanyIdentification_1 = require("./CompanyIdentification");
/**
 * Schema for the abn search validation
 * {@link IAcnSearchRequest}
 */
const acnSearchSchema = yup.object().shape({
    isForeignEntity: yup.boolean(),
    acn: yup
        .string()
        .required()
        .when("isForeignEntity", {
        is: true,
        then: (schema) => schema.trim().matches(CompanyIdentification_1.FOREIGN_IDENTIFICATION_NUMBER_REGEX, CompanyIdentification_1.FOREIGN_IDENTIFICATION_NUMBER_MESSAGE),
        otherwise: (schema) => schema.length(9).matches(/^\d*$/, "acn should contain only digits"),
    }),
});
exports.acnSearchSchema = acnSearchSchema;
/** Validates abn search request schema
 * @param data: abn search request {@link IAcnSearchRequest} to validate
 */
const validateAcnSearchRequest = async (data) => {
    try {
        await acnSearchSchema.validate(data, { abortEarly: false });
    }
    catch (err) {
        if (err instanceof yup.ValidationError) {
            const errorMessage = err.errors.toString();
            throw new ValidationError_1.ValidationError(errorMessage);
        }
        else {
            throw err;
        }
    }
};
exports.validateAcnSearchRequest = validateAcnSearchRequest;
//# sourceMappingURL=AcnValidation.js.map